import {
  FetchParams,
  Middleware,
  RequestContext,
} from '@neptune/shared/core-apis-middleware-domain';

const HEADER = 'X-Neptune-Client-Metadata';

type ResolverCallback = () => Promise<string>;

export const appendClientMetadataMiddlewareFactory: (resolver: ResolverCallback) => Middleware = (
  resolver,
) => ({
  async pre(context: RequestContext): Promise<FetchParams | void> {
    const headers = new Headers(context.init.headers);

    try {
      headers.append(HEADER, await resolver());
    } catch {
      return context;
    }

    return {
      ...context,
      init: {
        ...context.init,
        headers,
      },
    };
  },
});

let deferredMetadataResolver: ResolverCallback | null = null;

export const setDeferredClientMetadataResolver = (resolver: ResolverCallback) => {
  deferredMetadataResolver = resolver;
};

export const deferredClientMetadataWrapperResolver = () => {
  if (!deferredMetadataResolver) {
    throw new Error('Deferred client metadata resolver is not set');
  }

  return deferredMetadataResolver();
};
